import React, { useEffect } from "react";
import TextField from "@mui/material/TextField";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { subDays, addDays } from "date-fns";

export default function BasicDateRangePicker({
  onClickFilter,
  refreshData,
  autoTriggerFilter,
  style,
}) {
   const [value, setValue] = React.useState([
    subDays(new Date(), 7),
    addDays(new Date(), 1),
  ]);

  const normalizeDateRange = ([start, end]) => {
    if (!start || !end) return [null, null];

    const adjustedStart = new Date(start.setHours(0, 0, 0, 0));
    const adjustedEnd = new Date(end.setHours(23, 59, 59, 999));
    return [adjustedStart, adjustedEnd];
  };

  useEffect(() => {
    if (autoTriggerFilter && value[0] && value[1]) {
      onClickFilter(normalizeDateRange(value));
    }
  }, [autoTriggerFilter]);

  const handleFilterClick = () => {
    if (value[0] && value[1]) {
      onClickFilter(normalizeDateRange(value));
    } else {
      onClickFilter([null, null]);
    }
  };

  const handleClear = () => {
    setValue([null, null]);
    refreshData();
  };

  return (
    <div
      style={{
        display: "flex",
        gap: "15px",
        alignItems: "center",
        marginBottom: "8px",
        ...style,
      }}
    >
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DateRangePicker
          startText="Start date"
          endText="End date"
          value={value}
          onChange={(newValue) => {
            setValue(newValue);
          }}
          renderInput={(startProps, endProps) => (
            <>
              <TextField
                {...startProps}
                InputProps={{
                  sx: {
                    paddingX: "15px",
                  },
                }}
              />
              <Box sx={{ mx: 2 }}> to </Box>
              <TextField
                {...endProps}
                InputProps={{
                  sx: {
                    paddingX: "15px",
                  },
                }}
              />
            </>
          )}
        />
      </LocalizationProvider>
      <Button onClick={handleFilterClick} variant="contained">
        Filter
      </Button>
      <Button onClick={handleClear} variant="contained">
        Clear
      </Button>
    </div>
  );
}
